import React, { useState, useEffect, useRef } from "react";
import { SectionContent } from "./style";
import {
  ArrowBack,
  ArrowForwardWhite,
  BlankImage,
  CloseIcon,
  ConnectWallet,
  Discord,
  Globe,
  Instagram,
  LeafIcon,
  OwnedBy,
  Xtwitter,
} from "../../shared/icons";
import { NFTDetails } from "./Types";
import { Box, CircularProgress, Modal, Skeleton } from "@mui/material";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import styled from "styled-components";
import { screenSizes } from "../../styles/theme";
import WalletsModal from "../../components/New/WalletsModal";
import { showToast } from "../../slices/global/ToastSlice";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../store";
import ReadMoreParagraph from "../../components/New/ReadMoreParagraph";
import { getValidImageUrl } from "../../utils";
import { getWalletAddress, soldMarked } from "../../slices/nftDetails/nftDetailsThunks";
import { ethers } from "ethers";
import { Magic } from 'magic-sdk';
import { HederaExtension } from '@magic-ext/hedera';

import { MagicProvider } from './MagicProvider';
import { MagicWallet } from './MagicWallet';

import { useWallet } from "../../utils/WalletContext";


import Web3 from 'web3';

import { TransferTransaction, AccountId, Hbar } from '@hashgraph/sdk'


const HeroSection = styled.section`
  background-size: cover;
  padding: 30px 60px;
  height: auto;
  margin-top: 55px;
  @media (max-width: ${screenSizes.L}px) {
    height: auto;
    padding: 6rem 1rem 2rem 1rem;
    background: none;
    margin-top: 0;
  }
`;

const BackButton = styled.button`
  background: none;
  outline: none;
  border: none;
  display: flex;
  align-items: center;
  font-size: 16px;
  font-weight: 600;
  color: #091c00;
  cursor: pointer;
`;

const IconWrapper = styled.span`
  margin-right: 5px;
  display: flex;
  align-items: center;
  svg {
    width: 20px;
    height: 20px;
  }
`;

const ContentSection = styled.div`
  padding: 30px 100px;
  display: flex;
  column-gap: 80px;
  img {
    height: 520px;
    width: 520px;
    background-size: cover;
    object-fit: contain;
    background-position: center;
    @media (max-width: ${screenSizes.L}px) {
      height: auto;
      width: auto;
      margin-bottom: 2rem;
    }
  }
  @media (max-width: ${screenSizes.L}px) {
    flex-direction: column;
    padding: 0;
  }
`;

const InfoSection = styled.div`
  flex: 1;
  h6 {
    margin: 0;
    margin-bottom: 15px;
    font-weight: 400;
    font-size: 16px;
    color: #fff;
    margin-top: 0;
    line-height: 150%;
    span {
      position: relative;
      padding-left: 15px;
      &:before {
        content: "";
        position: absolute;
        left: 0;
        top: 5px;
        background: #fff;
        width: 8px;
        height: 8px;
        border-radius: 50px;
      }
    }
  }

  h2 {
    margin: 0;
    margin-block: 5px;
    display: flex;
    flex-direction: column;
    font-weight: 700;
    font-size: 48px;
    line-height: 56px;
    color: #091c00;
    font-family: Manrope, sans-serif;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    @media (max-width: ${screenSizes.L}px) {
      font-size: 32px;
      line-height: 40px;
      color: #091c00;
    }
  }

  div {
    display: flex;
    align-items: center;
    justify-content: space-between;
    @media (max-width: ${screenSizes.L}px) {
      display: block;
      color: #091c00;
    }
    .hover-container {
      display: flex;
      align-items: center;
      cursor: pointer;
    }

    .hover-image {
      height: 36px;
      width: 36px;
    }

    .hover-link {
      color: #091c00;
      text-decoration: underline;
      font-size: 16px;
      font-weight: 600;
    }

    .hover-container:hover .hover-image {
      filter: invert(68%) sepia(64%) saturate(370%) hue-rotate(344deg);
    }

    .hover-container:hover .hover-link {
      color: #ff9d59;
    }
    div {
      margin-right: 10px;
      display: flex;
      justify-content: left;
      img {
        width: 40px;
        height: 40px;
        margin-right: 10px;
        @media (max-width: ${screenSizes.L}px) {
          width: 32px;
          height: 32px;
          margin-block: auto;
        }
      }

      p {
        font-size: 16px;
        font-weight: 600;
        color: #091c00;
        @media (max-width: ${screenSizes.M}px) {
          font-size: 14px;
        }
        span {
          cursor: pointer;
        }
      }
    }
  }

  p {
    font-size: 16px;
    font-weight: 400;
    color: #091c00;
    line-height: 24px;
    display: -webkit-box;
    -webkit-line-clamp: 3; /* Limit to 3 lines */
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  div {
    button {
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      border: none;
      outline: none;
      background-color: #ff9d59;
      padding: 16px 20px;
      color: #fff;
      border-radius: 80px;
      gap: 10px;
      font-size: 18px;
      font-weight: 600;
      &:hover {
        background-color: #e0772d;
      }
      &:disabled {
      cursor: not-allowed;
      background-color:rgb(255, 183, 131);
      &:hover {
          background-color: rgb(255, 183, 131)
        }
      }
      span {
        display: flex;
        justify-content: center;
        align-items: center;
      }
      @media (max-width: ${screenSizes.L}px) {
        width: 100%;
      }
    }
  }
`;

const SocialIconsWrapper = styled.div`
  margin-left: 40px;
  display: flex;
  align-items: center;
  column-gap: 10px;
  color: #091c00;
  @media (max-width: ${screenSizes.L}px) {
    justify-content: center !important;
    margin-top: 30px;
    margin-inline: 1rem;
  }
  span {
    font-size: 14px;
    font-weight: 600;
    color: #091c00;
  }

  img {
    cursor: pointer;
    height: 24px !important;
    width: 24px !important;
    filter: brightness(0) saturate(100%) sepia(100%) hue-rotate(135deg)
      saturate(800%) contrast(90%);
    &:hover {
      filter: invert(42%) sepia(65%) saturate(334%) hue-rotate(344deg);
    }
  }
`;

const Rating = styled.div<{ value: number }>`
  display: flex;
  align-items: center;
  background-color: ${({ value }) =>
    value <= 3 ? "#C7FFC5" : value >= 6 ? "#FFC5C5" : "#feffc5"};
  border: 1px solid rgba(9, 28, 0, 0.1);
  padding: 0 8px;
  border-radius: 40px;
  justify-content: center;
  span {
    font-size: 14px;
    font-weight: 400;
    color: #091c00;
  }
`;

const UnitAndScore = styled.div`
  width: 100%;
  display: flex !important;
  justify-content: flex-start !important;
`;

const PurchaseScore = styled.div`
  justify-content: start !important;
  margin-block: 1.5rem;
  .score-bold {
    font-weight: 700;
    font-size: 24px
  }
  .score {
    font-weight: 400;
    font-size: 18px
  }
`;

const ModalButton = styled.a`
  text-decoration: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  outline: none;
  background-color: #ff9d59;
  padding: 15px;
  color: #fff;
  border-radius: 80px;
  gap: 10px;
  font-size: 18px;
  font-weight: 600;
  margin-top: 25px
`;

const PurchasedButton = styled.button`
  background: #FFE8D9 !important;
  border: 2px solid #FF9D59 !important;
  cursor: not-allowed !important;
  color: #FF9D59 !important;
  width: 180px !important;
  height: 54px !important;
  display: flex !important;
  justify-content: space-around !important;
  @media (max-width: ${screenSizes.L}px) {
    margin-bottom: 20px;
    width: 100% !important;
  }
`;
interface Props {
  nftDetails: NFTDetails | null;
  isLoading: boolean;
  getNFTDetailsRecord: ()=> void;
}

const NftHeroSection: React.FC<Props> = ({ nftDetails, isLoading, getNFTDetailsRecord }) => {
  const token = useSelector((state: RootState) => state?.auth?.token);
  const userAccountId = useSelector((state: RootState) => state?.auth?.user?.walletAddress);
  const dispatch: AppDispatch = useDispatch();
  const navigate = useNavigate();
  const isMobile = window.innerWidth <= 1024;
  const [walletModalOpen, setWalletModalOpen] = useState<boolean>(false);
  const [openTransactionModal, setTransactionModal] = useState<boolean>(false);
  const [purchasebtnLoader, setPurchasebtnLoader] = useState<boolean>(false);
  const [ transactionHash, setTransactionHash ] = useState<string>('');
  const [ walletAuthTypeLocal, setwalletAuthTypeLocal ] = useState<string>('');
  const [walletAddress, setWalletAddress] = useState('');
  const [walletAddressHBAR, setWalletAddressHBAR] = useState('');
  const location = useLocation();

  const { dAppConnector } = useWallet();
  
  const handleToggleModal = () => {
    setWalletModalOpen((prev) => !prev);
  };

  const handleTransactionModal = () => {
    setTransactionModal((prev) => !prev);
  }

  // Function to copy the URL to clipboard
  const copyToClipboard = (url: string, data: string) => {
    navigator.clipboard.writeText(url).then(() => {
      dispatch(
        showToast({
          message: `${data} copied to clipboard!`,
          severity: "success",
        })
      );
    });
  };

  const truncateId = (address: any) => {
    if (!address) return "";
    return `${address.slice(0, 6)}...${address.slice(-4)}`;
  };

  const appUrl = `https://vyga-dev-aggregator.web.app${location?.pathname}`;
  const handleShare = (platform: string) => {
    let shareUrl = "";

    switch (platform) {
      case "twitter":
        shareUrl = `https://twitter.com/intent/tweet?url=${encodeURIComponent(
          appUrl
        )}&text=Check out this awesome app!`;
        break;
      case "discord":
        shareUrl = `https://discord.com/channels/@me`;
        copyToClipboard(appUrl, "URL");
        return; // Discord needs manual sharing.
      case "instagram":
        copyToClipboard(appUrl, "URL");
        return; // Instagram needs manual sharing.
      default:
        return;
    }

    // Open share URL in a new tab
    window.open(shareUrl, "_blank");
  };
  const params = useParams();
  const prevParams = useRef(params);
  const networkType = nftDetails?.networkId === 1
  ? "ETH"
  : nftDetails?.networkId === 137
  ? "POL"
  : "HBAR";

  const handlePrice = (networkId: string|number|undefined, price: string|number) => {
    let newPrice = Number(nftDetails?.price)*1.1
    let calculatedPrice = (networkId === 1)
    ? Number(newPrice).toFixed(6)
    : (networkId === 295)
    ? Number(newPrice).toFixed(2)
    : Number(newPrice).toFixed(6);
    return calculatedPrice;
  }

  //-------- magic link --------

  const magic = new Magic(process.env.REACT_APP_MAGIC_PUBIC_KEY || "", {
    network: "sepolia", // Ethereum testnet
  });
  
  const magicHedara = new Magic(process.env.REACT_APP_MAGIC_PUBIC_KEY || "", {
    extensions: [new HederaExtension({
      network: 'testnet' // 'mainnet' or 'testnet'
    })]
  });


  const getWalletAddressData = () => {
    if(token){
      dispatch(getWalletAddress())
      .then((res: any) => {
        if (res?.error) {
          throw new Error(res?.payload);
        }
       
          setWalletAddressHBAR(res?.payload?.data?.data?.adminAddressHedera)
        
          setWalletAddress(res?.payload?.data?.data?.adminAddressEth)
        
      })
      .catch((err: any) => {
        console.log({err})
      })
    } else {
      setWalletAddress('');
    }
  }

  useEffect(() => {
    if (JSON.stringify(prevParams.current) !== JSON.stringify(params)) {
      getNFTDetailsRecord();
    }
    prevParams.current = params;
  }, [params]);

  useEffect(()=>{
    getWalletAddressData();
  }, []);


  const uint8ArrayToHex = (uint8Array:any) => {
    return Array.from(uint8Array)
      .map((byte:any) => byte.toString(16).padStart(2, "0"))
      .join("");
  };

  const paymentMetaMask = async(recipient: string, amount: string) => {

    const providers = (window.ethereum as any)?.providers || [window.ethereum];

  // Find MetaMask provider
  const metaMaskProvider = providers.find(
    (provider: any) =>
      provider && provider.isMetaMask && !provider.overrideIsMetaMask
  );

  // Fall back to window.ethereum if no providers are found (for Safari)
  const selectedProvider =
    metaMaskProvider ||
    ((window.ethereum as any)?.isMetaMask ? window.ethereum : null);


    if (!selectedProvider) {
      dispatch(
        showToast({
          message: "MetaMask is required!",
          severity: "error",
        })
      );
    }

    const provider = new ethers.providers.Web3Provider(metaMaskProvider);
    const signer = provider.getSigner();
    amount = Number(amount).toFixed(8);
    try {
      const tx = await signer.sendTransaction({
        to: recipient,
        value: ethers.utils.parseEther(amount),
      });
      console.log("Transaction sent! Hash:", tx.hash);
      await tx.wait();
      console.log("Transaction confirmed:", tx);
      await setTransactionHash(tx.hash);
      setTransactionModal(true);
      handlePaymentSuccess();
    } catch (error) {
      console.log('payment error', error);
      dispatch(
        showToast({
          message: `${JSON.parse(JSON.stringify(error)).reason}`,
          severity: "error",
        })
      );
      setPurchasebtnLoader(false);
    }
  }
  
  const paymentCoinbaseWallet = async(recipient: string, amount: string) => {

    const providers = (window.ethereum as any)?.providers || [window.ethereum];

      // Find Coinbase Wallet provider
      const coinbaseProvider = providers.find(
        (provider: any) =>
          provider && (provider.isCoinbaseWallet || provider.overrideIsMetaMask)
      );

      // Fall back to window.ethereum if no providers are found (for Safari)
      const selectedProvider =
        coinbaseProvider ||
        ((window.ethereum as any)?.isCoinbaseWallet ? window.ethereum : null);

      if (!selectedProvider) {
        dispatch(
          showToast({
            message: "Coinbase Wallet is required!",
            severity: "error",
          })
        );
        setPurchasebtnLoader(false);
        return;
      };

    // Initialize Coinbase Wallet Provider
    const provider = new ethers.providers.Web3Provider(coinbaseProvider);
    const signer = await provider.getSigner();
    amount = Number(amount).toFixed(8);
    try {
      const tx = await signer.sendTransaction({
        to: recipient,
        value: ethers.utils.parseEther(amount),
      });
      console.log("Transaction sent! Hash:", tx.hash);
      await setTransactionHash(tx.hash);
      await tx.wait();
      console.log("Transaction confirmed:", tx);
      setTransactionModal(true);
      handlePaymentSuccess();
    } catch (error) {
      console.log("Payment error", error);
      setPurchasebtnLoader(false);
      dispatch(
        showToast({
          message: `${error}`,
          severity: "error",
        })
      );
    }
  }

  const paymentMagicLink = async (recipient: string, amountPassed: string) => {
    console.log('paymentMagicLink called', recipient, amountPassed);
    // const publicAddress:any = (await magic.user.getMetadata()).publicAddress;

    //   console.log("publicAddress address:", publicAddress);
    
    const web3 = new Web3(magic.rpcProvider);
    const accounts = await web3.eth.getAccounts();
    const fromAddress = accounts[0];

    try {
     

      // const fromAddress:any = accountId;
      const amount = web3.utils.toWei(amountPassed, "ether");

      const provider = new ethers.providers.Web3Provider(magic.rpcProvider as unknown as ethers.providers.ExternalProvider);

      const signer = provider.getSigner();
      const userAddress = await signer.getAddress();
      
      console.log("Authenticated address:", userAddress);


      // console.log('accounts',accounts);
      console.log('userAccountId',userAccountId);
      console.log('fromAddress',fromAddress);
      console.log('userAddress',userAddress);
      console.log('recipient',recipient);
      const txnParams = {
        // from: accountId|| "",
        from: fromAddress,
        to: recipient,
        value: amount,
        gas: 21000
      };
      web3.eth
        .sendTransaction(txnParams)
        .on("transactionHash", async (hash) => {
          console.log("Transaction hash:", hash);
          await setTransactionHash(hash);
        })
        .then((receipt) => {
          setTransactionModal(true);
          handlePaymentSuccess();
          console.log("Transaction receipt:", receipt);
        })
        .catch((error:any) => {
          console.error("Transaction error:", error);
          let errorMessage = "Something went wrong!";
          if (error?.code === -32603 && error?.message.includes("User canceled")) {
            errorMessage = "Transaction was canceled by the user!";
          } else if(error?.code === -32603 && error?.message.includes("insufficient funds")){
            errorMessage = "Insufficient funds for the transaction!";
          } else if (error?.message) {
            errorMessage = error.message;
          }
          dispatch(
            showToast({
              message: errorMessage,
              severity: "error",
            })
          );
          setPurchasebtnLoader(false);
        });
    } catch (error) {
      console.error("Error fetching account:", error);
      dispatch(
        showToast({
          message: "Error while fetching account!",
          severity: "error",
        })
      );
      setPurchasebtnLoader(false);
    }
  };


  const paymentMagicLinkHedera = async (recipient: string, amountPassed: string) => {
    try {

      magicHedara.user.isLoggedIn().then(async magicIsLoggedIn => {
        
        if (magicIsLoggedIn) {
          const publicAddress:any = (await magicHedara.user.getMetadata()).publicAddress;

          console.log('publicAddress',publicAddress);
          // setPublicAddress(publicAddress);
          // setUserMetadata(await magic.user.getMetadata());

      const destinationAddress = recipient;

      const { publicKeyDer } = await magicHedara.hedera.getPublicKey()

      const magicSign = (message:any) => magicHedara.hedera.sign(message);

      const magicWallet = new MagicWallet(publicAddress, new MagicProvider('testnet'), publicKeyDer, magicSign, magicSign)

     let sendAmount = Number("0.00002");

      let transaction = await new TransferTransaction()
            .setNodeAccountIds([new AccountId(3)])
            .addHbarTransfer(publicAddress, -1 * sendAmount)
            .addHbarTransfer(destinationAddress, sendAmount)
            .freezeWithSigner(magicWallet);



      transaction = await transaction.signWithSigner(magicWallet);
      const response = await transaction.executeWithSigner(magicWallet);
      // const receipt = await result.getReceiptWithSigner(magicWallet);
      // console.log('receipt',receipt);
      // console.log(receipt.status.toString());


      console.log('response',response);
      
      let transactionHash = response?.transactionHash;
      console.log('transactionHash', transactionHash);

      const uint8Array = new Uint8Array(transactionHash);
      const transactionHashText = uint8ArrayToHex(uint8Array)
      console.log('transactionHashText',transactionHashText); 

      setPurchasebtnLoader(false);
      await setTransactionHash(transactionHashText);

      setTransactionModal(true);
      handlePaymentSuccess();

      }
    });

    } catch (error) {
      console.error("Error fetching account:", error);
      dispatch(
        showToast({
          message: "Error while fetching account!",
          severity: "error",
        })
      );
      setPurchasebtnLoader(false);
    }
  };


  const projectId:any = process.env.REACT_APP_HASHPACK_PROJECT_ID;

  const metadata = {
    name: 'vyga',
    description: 'vyga description',
    url: process.env.REACT_APP_HASHPACK_URL ?? "",
    icons: [process.env.REACT_APP_HASHPACK_ICON_URL ?? ""],
  };

//   let dAppConnector:any;

//   // Initialize and set up event listeners
//  const initializeWalletConnect = async() => {
//   dAppConnector = new DAppConnector(
//     metadata,
//     // LedgerId.MAINNET,
//     LedgerId.TESTNET,
//     projectId,
//     Object.values(HederaJsonRpcMethod),
//     [HederaSessionEvent.ChainChanged, HederaSessionEvent.AccountsChanged],
//     [HederaChainId.Testnet], // Mainnet and Testnet
//   )
//   await dAppConnector.init({ logger: 'error' })

//   dAppConnector.onSessionIframeCreated = (session:any) => {
//     // handleNewSession(session)
//   }
// }

  const paymentHashpackWallet = async(recipient: string, amountPass: string) => {
   
    try {
    
    console.log('dAppConnector',dAppConnector);

    if (!dAppConnector) {
        console.error("dAppConnector is not initialized");
        return <p>Loading wallet...</p>;
    }

      const amount = "0.002";
      const accountIdGet  = userAccountId ?? "";
      console.log('accountIdGet', accountIdGet);
      console.log('recipient', recipient);
      // let signer:any = hashconnect.getSigner(AccountId.fromString(accountIdGet));


      console.log('dAppConnectordAppConnector',dAppConnector);

      // Ensure dAppConnector is initialized
      if (!dAppConnector) {
        console.error('dAppConnector is undefined. Ensure it is initialized before calling this function.');
        return;
      }

      // Ensure signers exist
      if (!dAppConnector.signers || !Array.isArray(dAppConnector.signers)) {
        console.error('dAppConnector.signers is missing or not an array', dAppConnector);
        return;
      }

      // Get the signer for the connected account
        const accountId = localStorage.getItem('hederaAccountId')
        const signer:any = dAppConnector.signers.find(
          (signer_:any) => signer_.getAccountId().toString() === accountIdGet,
        )
        console.log('signer',signer);
   
        
      let transaction = await new TransferTransaction()
          .addHbarTransfer(accountIdGet, new Hbar(-amount))
          .addHbarTransfer(recipient, new Hbar(amount))
          .freezeWithSigner(signer);
      // let response = await hashconnect.sendTransaction(AccountId.fromString(accountIdGet), transaction);
      let response = await transaction.executeWithSigner(signer);
      // let receipt = await response.getReceiptWithSigner(signer);
      console.log('response', response);
      // console.log('receipt', receipt);

      let transactionHash = response?.transactionHash;
      console.log('transactionHash', transactionHash);

      const uint8Array = new Uint8Array(transactionHash);
      const transactionHashText = uint8ArrayToHex(uint8Array)
      console.log('transactionHashText',transactionHashText); 


      // dispatch(
      //   showToast({
      //     message: `Payment Successful!`,
      //     severity: "success",
      //   })
      // );
      setPurchasebtnLoader(false);
      await setTransactionHash(transactionHashText);

      setTransactionModal(true);
      handlePaymentSuccess();
    } catch (error:any) {
      console.log("Payment error", error);
      if (error.code === 9000) {
        console.log('iffff');
        console.log('error.message', error.message);
        if (typeof error.message === "object" && error.message?._code === 10) {
          
            if (error.data?.status === "INSUFFICIENT_PAYER_BALANCE") {
                dispatch(
                  showToast({
                    message: `Insufficient payer balance. Transaction failed.`,
                    severity: "error",
                  })
                );
            }
        } else if (error.message === "USER_REJECT") {
            dispatch(
              showToast({
                message: `User rejected the transaction.`,
                severity: "error",
              })
            );
        } else {
            console.error("Unhandled payment error:", error);
             dispatch(
                showToast({
                  message: `${error}`,
                  severity: "error",
                })
              );
        }
      }    
      setPurchasebtnLoader(false);
    }
  }
  
  const handlePurchase = () => {
    
    const totalPrice = Number(nftDetails?.price)*1.1;
    // const totalPriceStatic = totalPrice;
    const totalPriceStatic = "0.00002";

    let walletAuthType = localStorage.getItem('walletAuthType');
    setwalletAuthTypeLocal(walletAuthType || "none");
    console.log('walletAuthType', walletAuthType)
    setPurchasebtnLoader(true);
    if(totalPrice <= 0){
      dispatch(
        showToast({
          message: `Price should be greater than 0!`,
          severity: "error",
        })
      );
      setPurchasebtnLoader(false);
    } else {
      
      //networkId = 295 hedara, 1= Etherium, 137= plygon
      if(nftDetails?.networkId === 295 && walletAuthType == 'Hashpack'){
        paymentHashpackWallet(walletAddressHBAR, (totalPriceStatic).toString());
      }else if(nftDetails?.networkId === 295 && walletAuthType == 'Magiclink'){
        paymentMagicLinkHedera(walletAddressHBAR, (totalPriceStatic).toString())
      }else if(nftDetails?.networkId === 1 || nftDetails?.networkId === 137){
        if(walletAuthType == 'MetaMask'){
          paymentMetaMask(walletAddress, (totalPriceStatic).toString());
        }else if(walletAuthType == 'Coinbase'){
          paymentCoinbaseWallet(walletAddress, (totalPriceStatic).toString());
        }else if(walletAuthType == 'Magiclink'){
          paymentMagicLink(walletAddress, (totalPriceStatic).toString())
        }else if(walletAuthType == 'Hashpack'){
          dispatch(
            showToast({
              message: `Please login with Hashpack and try again!`,
              severity: "error",
            })
          );
          setPurchasebtnLoader(false);
        }
      }else{
        dispatch(
          showToast({
            message: `Please connect to the wallet and try again!`,
            severity: "error",
          })
        );
        setPurchasebtnLoader(false);
      }
    }
  }

  const handlePaymentSuccess = () => {
  const id:string = nftDetails ?  nftDetails.id : '';
    const data = {
      nftId: id
    };
    dispatch(soldMarked(data))
      .then((res: any) => {
        if (res?.error) {
          throw new Error(res?.payload);
        }
        dispatch(
          showToast({
            message: "Payment Successful!",
            severity: "success",
          })
        );
        setPurchasebtnLoader(false);
      })
      .catch((err) => {
        dispatch(
          showToast({
            message: err.message || "Something went wrong!",
            severity: "error",
          })
        );
        setPurchasebtnLoader(false);
      })
      .finally(() => {
        getNFTDetailsRecord();
      });
  };

  return (
    <>
      <HeroSection>
        {!isMobile && (
          <BackButton onClick={() => navigate(-1)}>
            <IconWrapper>
              <ArrowBack />
            </IconWrapper>
            &nbsp; Back
          </BackButton>
        )}

        {isLoading ? (
          <ContentSection>
            <Skeleton variant="rectangular" width={500} height={500} />
            <SectionContent>
              <div style={{ marginBottom: "20px" }}>
                <Skeleton variant="rectangular" width={120} height={20} />
              </div>
              <h1 style={{ marginBottom: "20px" }}>
                <Skeleton variant="rectangular" width={400} height={80} />
              </h1>
              <div style={{ marginBottom: "20px" }}>
                <Skeleton variant="rectangular" width={450} height={30} />
              </div>
              <div style={{ marginBottom: "20px" }}>
                <Skeleton variant="rectangular" width={600} height={200} />
              </div>
              <div>
                <Skeleton variant="rectangular" width={420} height={30} />
              </div>
            </SectionContent>
          </ContentSection>
        ) : (
          <ContentSection>
            <img
              src={getValidImageUrl(nftDetails?.featureImage ?? "", BlankImage)}
              onError={(e) => {
                const target = e.target as HTMLImageElement;
                target.src = BlankImage;
              }}
              alt="nft_image"
            />
            <InfoSection>
              <UnitAndScore>
                <div
                  style={{
                    padding: "2px 16px",
                    border: "1px solid #091C00 ",
                    borderRadius: "40px",
                    display: "inline-flex",
                    fontSize: "12px",
                    fontWeight: 500,
                    color: "#091C00",
                  }}
                >
                  {networkType}
                </div>
                <Rating value={nftDetails?.score || 1}>
                  <LeafIcon />
                  <span>
                    {typeof nftDetails?.score === "number"
                      ? nftDetails.score.toFixed(1)
                      : "0"}
                  </span>
                </Rating>
              </UnitAndScore>

              {/* <Badge>
                <img src={Diamond} alt="icon" />
                Top 20 on{" "}
                {networkType}
              </Badge> */}
              <h2 title={nftDetails?.name}>{nftDetails?.name}</h2>
              <div>
                {nftDetails?.createdBy && (
                  <div>
                    <img
                      src={OwnedBy}
                      alt=""
                      style={{
                        border: "2px solid #FF9D59",
                        borderRadius: "40px",
                      }}
                    />
                    <p>
                      Created by |{" "}
                      <span
                        onClick={() =>
                          copyToClipboard(nftDetails?.createdBy, "ID")
                        }
                        title={nftDetails?.createdBy}
                      >
                        {nftDetails?.createdBy.length > 15
                          ? truncateId(nftDetails?.createdBy)
                          : nftDetails?.createdBy}
                      </span>
                    </p>
                  </div>
                )}
                {nftDetails?.externalLink && (
                  <div className="hover-container">
                    <img src={Globe} alt="" className="hover-image" />
                    <a
                      href={nftDetails?.externalLink || "#"}
                      target="_blank"
                      rel="noreferrer"
                      className="hover-link"
                    >
                      Original Page Link
                    </a>
                  </div>
                )}
              </div>
              {nftDetails?.description &&
                nftDetails?.description.length > 0 && (
                  <div style={{marginBlock: '1rem'}}>
                  <ReadMoreParagraph content={nftDetails?.description} />
                  </div>
                )}
              <PurchaseScore>
                <span className="score-bold">{handlePrice(nftDetails?.networkId, nftDetails?.price)} {networkType} +</span>
                <span className="score">&nbsp;(10% VYGA fee)</span>
                {/* <span className="score">&nbsp;(10% VYGA + gas fee)</span> */}
              </PurchaseScore>
              <div>
                {/*}
                {walletAddress ? (
                  !!nftDetails?.isActive
                    ?
                  <button disabled={purchasebtnLoader} onClick={handlePurchase} style={{ position: "relative", minWidth: "150px" }}>
                    {"Purchase Now"}{purchasebtnLoader ? <CircularProgress size={20} color="inherit" /> : <ArrowForwardWhite />}
                  </button>
                  :
                  <PurchasedButton>
                    Purchased
                  </PurchasedButton>
                ) : (
                  <button onClick={handleToggleModal}>
                    Connect to Purchase
                    <span>
                      <ConnectWallet />
                    </span>
                  </button>
                )}
                */}

                <SocialIconsWrapper>
                  <span>Share on:</span>
                  <img
                    src={Instagram}
                    alt="icon"
                    onClick={() => handleShare("instagram")}
                  />
                  <img
                    src={Discord}
                    alt="icon"
                    onClick={() => handleShare("discord")}
                  />
                  <img
                    src={Xtwitter}
                    alt="icon"
                    onClick={() => handleShare("twitter")}
                  />
                </SocialIconsWrapper>
              </div>
            </InfoSection>
          </ContentSection>
        )}
      </HeroSection>
      <WalletsModal open={walletModalOpen} handleClose={handleToggleModal} />

      {/* Transaction success modal */}
      <Modal
        open={openTransactionModal}
        onClose={handleTransactionModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "#fff",
            boxShadow: 24,
            padding: "20px",
          }}>
          <Box
            sx={{
              textAlign: "right",
              cursor: "pointer",
            }}
            onClick={handleTransactionModal}
          >
            <CloseIcon />
          </Box>
          <Box
            sx={{
              textAlign: "center",
              padding: "20px"
            }}
          >
            <h2>Congrations!</h2>
            <h4>Your payment has succeeded</h4>
            <ModalButton target="_blank" rel="noopener noreferrer"
              href={ nftDetails?.networkId == 295 ? `https://hashscan.io/testnet/transaction/${transactionHash}` : `https://sepolia.etherscan.io/tx/${transactionHash}`}>
              View Transaction Details
            </ModalButton>
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default NftHeroSection;
